import { DataZoomComponentOption, EChartsInitOpts, EChartsOption } from 'echarts';

export const formatter2decimal = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatterCurrency = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const DEFAULT_INITOPTS: EChartsInitOpts = {
  renderer: 'svg',

}


export const DEFAULT_CHART: EChartsOption = {
  backgroundColor: 'transparent',
  animation: true,
  animationDuration: 400,
  animationEasing: 'quarticOut',
  animationDelayUpdate: (idx) => idx * 10,

  stateAnimation: { duration: 200, easing: 'quarticOut' },
  // emphasis: { focus: 'series', blurScope: 'coordinateSystem' },

  // Tipografia global
  textStyle: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji"',
  },

  tooltip: {
    show: true,
    trigger: 'axis',
    appendToBody: true,
    backgroundColor: 'var(--chart-tooltip-bg, var(--current-bg, #fff))',
    borderColor: 'transparent',
    extraCssText: 'box-shadow: 0 8px 24px rgba(0,0,0,.08); border-radius: 10px; padding: 10px 12px;',
    textStyle: { color: 'var(--chart-tooltip-fg, var(--tw-gray-700))', fontSize: 12 },
    // axisPointer: {
    //   type: 'cross',
    //   crossStyle: { color: 'var(--tw-gray-300,#d1d5db)', width: 1 },
    //   label: {
    //     backgroundColor: 'var(--chart-tooltip-label-bg, #1f2937)',
    //     color: 'var(--chart-tooltip-label-fg, #fff)'
    //   }
    // },
    axisPointer: {
      type: 'shadow'
    },
  },

  color: [
    '#6366f1',
    '#22d3ee',
    '#10b981',
    '#f59e0b',
    '#ef4444',
    '#94a3b8',
  ],

  grid: {
    // left: 24,
    // right: 16,
    // top: 48,
    // bottom: 36,
    containLabel: true,
  },

  // legend: {
  //   show: false,
  //   top: 'center',
  //   right: 0,
  // },

  xAxis: {
    type: 'value',
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: {
      // color: 'var(--tw-gray-600,#4b5563)',
      fontSize: 11,
      margin: 8,
    }
  },

  yAxis: {
    type: 'value',
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: {
      // color: 'var(--tw-gray-600,#4b5563)',
      fontSize: 11,
      margin: 8,
    }
  },

  // media: [
  //   // telas pequenas
  //   {
  //     query: { maxWidth: 480 },
  //     option: {
  //       legend: { top: 4 },
  //       grid: { top: 40, right: 12, left: 8, bottom: 20 },
  //       xAxis: { axisLabel: { fontSize: 10, margin: 8 } },
  //       yAxis: { axisLabel: { fontSize: 10, margin: 6 } },
  //     }
  //   }
  // ],
};

// export const DEFAULT_DATAZOOM_SCROLLBAR: DataZoomComponentOption =
export const DEFAULT_DATAZOOM_SCROLLBAR: any =
{
  type: 'slider',
  yAxisIndex: 0,
  zoomLock: true,
  brushSelect: false,
  width: 8,
  right: 0,

  labelFormatter: function () {
    return ''; // Retorna uma string vazia para ocultar os rótulos
  },
  // handleSize: 0,
  backgroundColor: 'var(--p-navigation-item-focus-background)',
  dataBackground: {
    areaStyle: {
      color: 'transparent',
      shadowColor: 'transparent'
    },
    lineStyle: {
      color: 'transparent',
      shadowColor: 'transparent'
    },
  },

  borderColor: 'transparent',
  fillerColor: 'var(--p-text-color)',

  borderWidth: 0,
  zoomOnMouseWheel: 'shift',
  moveOnMouseWheel: true,
  showDetail: false,
  borderRadius: 999,
  showDataShadow: undefined,
  brushStyle: { borderWidth: 0, borderColor: 'var(--p-text-color)', color: 'var(--p-text-color)', borderCap: 'round', borderJoin: 'bevel', borderRadius: 0 },
  handleStyle: { borderWidth: 0, borderColor: 'var(--p-text-color)', color: 'var(--p-text-color)', borderCap: 'round', borderJoin: 'bevel', borderRadius: 0 },
  moveHandleStyle: { borderWidth: 0, borderColor: 'var(--p-text-color)', color: 'var(--p-text-color)', borderCap: 'round', borderJoin: 'bevel', borderRadius: 0 },

}

export const DEFAULT_DATAZOOM_SCROLLBAR_HORIZONTAL: DataZoomComponentOption =
{
  ...DEFAULT_DATAZOOM_SCROLLBAR,
  width: 'auto',
  height: 8,
  left: 16,
  bottom: 4,
  yAxisIndex: undefined,
  xAxisIndex: 0
}

export const DEFAULT_DATAZOOM_DRAG: DataZoomComponentOption =
{
  type: 'inside',
  zoomOnMouseWheel: false,
  moveOnMouseWheel: true,
  // start: 0,
  yAxisIndex: 0,
}

export const FORMATTER_NUMBER_ABBREVIATION = {
  formatter: function (value: any) {
    if (isNaN(value)) return value;
    value = Number(value);

    const formatValue = (num: number) =>
      Number.isInteger(num) ? num : num.toFixed(2);

    const absValue = Math.abs(value);

    if (absValue >= 1000000) {
      return formatValue(value / 1000000) + 'M';
    } else if (absValue >= 1000) {
      return formatValue(value / 1000) + 'k';
    } else {
      return formatValue(value);
    }
  }
};



export const VALUEFORMATTER_NUMBER_2DECIMAL = {
  valueFormatter: (value: any) => {
    return formatter2decimal.format(value);
  }
}

export const VALUEFORMATTER_NUMBER_CURRENCY = {
  valueFormatter: (value: any) => {
    return formatterCurrency.format(value);
  }
}

export const FORMATTER_2DAYS_MONTH = {
  formatter: (value: number) => {
    const d = new Date(value);
    const dia = d.toLocaleDateString(undefined, { day: "2-digit" });
    const mes = d.toLocaleDateString(undefined, { month: "short" });
    // se o ano for diferente do atual, adicionar o ano
    const anoAtual = new Date().getFullYear();
    const ano = d.getFullYear() !== anoAtual ? ` ${d.getFullYear()}` : '';
    return `${dia} ${mes.charAt(0).toUpperCase() + mes.slice(1)}${ano}`; // 15 set
  }
}

export const VALUEFORMATTER_NUMBER_PERCENT = {
  valueFormatter: (value: any) => {
    return formatter2decimal.format(value) + '%';
  }
}

export const FUNCTION_NUMBER_PERCENT_AND_CURRENCY = (value: any, total: any) => {
  const a = VALUEFORMATTER_NUMBER_PERCENT.valueFormatter(Number(value) / Number(total) * 100);
  const b = VALUEFORMATTER_NUMBER_CURRENCY.valueFormatter(value)
  return `(${a})  ${b}`;
}

export const FUNCTION_NUMBER_PERCENT_AND_CURRENCY_HTML = (value: any, total: any) => {
  const a = VALUEFORMATTER_NUMBER_PERCENT.valueFormatter(Number(value) / Number(total) * 100);
  const b = VALUEFORMATTER_NUMBER_CURRENCY.valueFormatter(value)
  return `<b>(${a})</b>  ${b}`;
}

export const FUNCTION_NUMBER_PERCENT_AND_VALUE_HTML = (value: any, total: any) => {
  const a = VALUEFORMATTER_NUMBER_PERCENT.valueFormatter(Number(value) / Number(total) * 100);
  const b = value;
  return `<b>(${a})</b>  ${b}`;
}


// // https://echarts.apache.org/en/api.html#echartsInstance.showLoading
// export const DEFAULT_LOADINGOPTS = {
//   text: '',
//   color: '#4D64FF',
//   textColor: '#000',
//   maskColor: 'rgba(255, 255, 255, 0.0)',
//   zlevel: 0,

//   // Font size. Available since `v4.8.0`.
//   fontSize: 12,
//   // Show an animated "spinner" or not. Available since `v4.8.0`.
//   showSpinner: true,
//   // Radius of the "spinner". Available since `v4.8.0`.
//   spinnerRadius: 25,
//   // Line width of the "spinner". Available since `v4.8.0`.
//   lineWidth: 5,
//   // Font thick weight. Available since `v5.0.1`.
//   fontWeight: 'normal',
//   // Font style. Available since `v5.0.1`.
//   fontStyle: 'normal',
//   // Font family. Available since `v5.0.1`.
//   fontFamily: 'sans-serif'
// }




